import React from "react"
import { toast } from "sonner"
import { Stack, Typography, CircularProgress } from "@mui/material"
import {toastStyle} from "./ErrorToastMessage"

export const renderInProgressToast = (
  message: string,
) => {
  const id = toast.info(
    <Stack direction="row" spacing={"4px"} sx={{ alignItems: "center" }}>
      <Typography sx={{ fontSize: "15px" }}>{message}</Typography>
      <CircularProgress size={20} sx={{ flexShrink: 0 }} />
    </Stack>,
    { style: { ...toastStyle }, duration: Infinity }
  )
  return id
}
